export const state = {
    posVenda: {},
    posVendas: [],
    modalExcluirPosVenda: false,
    modalCadastroPosVenda: false,
    modalVisualizarPosVenda: false,
    modalFinalizarPosVenda: false,
}

export default {}